import { useEffect } from 'react';
import { CanView } from 'components/Can';
import { TabView, TabPanel } from 'primereact/tabview';
import { Title } from 'components/Title';
import MandateworldListPage from 'pages/mandateworld/List';
import useApp from 'hooks/useApp';
import VendordocsListPage from 'pages/vendordocs/List';

const MasterDetailPages = (props) => {
		const app = useApp();
	const { masterRecord, scrollIntoView = true } = props;
	const activeTab = 0;
	function scrollToDetailPage() {
		if (scrollIntoView) {
			const pageElement = document.getElementById('master-detailpage');
			if(pageElement){
				pageElement.scrollIntoView({behavior:'smooth', block:'start'});
			}
		}
	}
	// pass form data from master to detail
	function setDetailPageFormData(){
		const record = masterRecord;
		// set  form data
		const mandateworldFormData = { userid:record?.userid }
		app.setPageFormData('mandateworld', mandateworldFormData);
		// set  form data
		const vendordocsFormData = {  }
		app.setPageFormData('vendordocs', vendordocsFormData);
	}
	// pass form data from master to detail
	useEffect(() => {
		scrollToDetailPage();
		setDetailPageFormData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [masterRecord]);
	if(masterRecord){
		return (
<div id="master-detailpage">
    <TabView value={activeTab}>
        <TabPanel header={<Title title="User Mandateworld"  headerClass="p-0" titleClass="text-lg font-bold"  iconClass="pi pi-th-large" avatarSize="small"    separator={false} />}>
            <CanView pagePath="mandateworld">
                <div className="reset-grid">
                    <MandateworldListPage isSubPage  fieldName="userid" fieldValue={masterRecord.userid} showBreadcrumbs={false} showHeader={false} showFooter={true}>
                    </MandateworldListPage>
                </div>
            </CanView>
        </TabPanel>
        <TabPanel header={<Title title="User Vendordocs"  headerClass="p-0" titleClass="text-lg font-bold"  iconClass="pi pi-th-large" avatarSize="small"    separator={false} />}>
            <CanView pagePath="vendordocs">
                <div className="reset-grid">
                    <VendordocsListPage isSubPage  fieldName="userid" fieldValue={masterRecord.userid} showBreadcrumbs={false} showHeader={false} showFooter={true}>
                    </VendordocsListPage>
                </div>
            </CanView>
        </TabPanel>
    </TabView>
</div>
		);
	}
}
export default MasterDetailPages;
